var map = {
	"./contact-appt.svg": 536,
	"./contact-email.svg": 537,
	"./contact-fin.svg": 538,
	"./contact-hours.svg": 539,
	"./contact-npat.svg": 540,
	"./footer-phone.svg": 541,
	"./footer-pin.svg": 542,
	"./footer-user.svg": 543,
	"./logo-simple.svg": 544,
	"./logo.svg": 545,
	"./modal-close.svg": 546,
	"./new-logo-2.svg": 547,
	"./new-logo.svg": 548,
	"./op-smiles-logo.svg": 549,
	"./phone.svg": 550,
	"./rg.svg": 551,
	"./slider-next-white.svg": 133,
	"./slider-prev-white.svg": 134,
	"./sosh-fb-white.svg": 552,
	"./sosh-fb.svg": 553,
	"./sosh-g-white.svg": 554,
	"./sosh-g.svg": 555,
	"./sosh-ig.svg": 556,
	"./sosh-twit.svg": 557,
	"./sosh-yt.svg": 558
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 667
// module chunks = 1